import api from "@/api/index.ts";
import { IShop, IInitState } from "../interfaces/shops";
import { factoryShops } from "../../services/factory/shops";
import { MERCHANTS_PER_PAGE } from "@/config";

const initShopsState: IInitState = {
  shops: [],
  categoryList: [
    {
      id: "A",
      symbol: "A"
    },
    {
      id: "B",
      symbol: "B"
    },
    {
      id: "C",
      symbol: "C"
    },
    {
      id: "D",
      symbol: "D"
    },
    {
      id: "E",
      symbol: "E"
    },
    {
      id: "F",
      symbol: "F"
    },
    {
      id: "G",
      symbol: "G"
    },
    {
      id: "H",
      symbol: "H"
    },
    {
      id: "I",
      symbol: "I"
    },
    {
      id: "J",
      symbol: "J"
    },
    {
      id: "K",
      symbol: "K"
    },
    {
      id: "L",
      symbol: "L"
    },
    {
      id: "M",
      symbol: "M"
    },
    {
      id: "N",
      symbol: "N"
    },
    {
      id: "O",
      symbol: "O"
    },
    {
      id: "P",
      symbol: "P"
    },
    {
      id: "Q",
      symbol: "Q"
    },
    {
      id: "R",
      symbol: "R"
    },
    {
      id: "S",
      symbol: "S"
    },
    {
      id: "T",
      symbol: "T"
    },
    {
      id: "U",
      symbol: "U"
    },
    {
      id: "V",
      symbol: "V"
    },
    {
      id: "W",
      symbol: "W"
    },
    {
      id: "X",
      symbol: "X"
    },
    {
      id: "Y",
      symbol: "Y"
    },
    {
      id: "Z",
      symbol: "Z"
    },
    {
      id: "num",
      symbol: "0-9"
    }
  ]
};
const letters: string[] = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "0-9"
];

export default {
  namespaced: true,
  state: initShopsState,
  mutations: {
    shopsSuccess(state: IInitState, shops: IShop[]) {
      state.shops = shops;
    },
    letter(state: IInitState, letters) {
      state.categoryList = letters;
    },

    updateLetter(state: IInitState, [data, letter]) {
      state.shops.forEach(element => {
        if (element.letter === letter) {
          element.merchants = element.merchants.concat(data);
          return;
        }
      });
    }
  },
  actions: {
    getAllShops({ commit }) {
      let shops: IShop[] = [];
      commit("shopsSuccess", shops);
      commit("letter", []);
      api.getMerchants(letters, MERCHANTS_PER_PAGE).then(res => {
        shops = factoryShops(res.data.merchantsByLetters);
        let newArray = shops.map(el => {
          if (el.count > 0) {
            return {
              symbol: el.letter.toUpperCase(),
              id: el.letter === "0-9" ? "num" : el.letter.toUpperCase()
            };
          } else {
            return null;
          }
        });
        commit("letter", newArray);
        commit("shopsSuccess", shops);
      });
    },

    showMoreShops({ commit }, { letter, counter, load }) {
      api
        .getMerchants(letter, counter)
        .then(res => {
          commit("updateLetter", [res.data.merchants, letter]);
        })
        .then(() => {
          load.style.display = "none";
        });
    }
  },
  getters: {
    getShops: (state: IInitState) => state.shops,
    getCategoryList: (state: IInitState) => state.categoryList
  }
};
